import { render, staticRenderFns } from "./TextFieldReadonlyCopy.vue?vue&type=template&id=4697a02c&scoped=true&"
import script from "./TextFieldReadonlyCopy.vue?vue&type=script&lang=js&"
export * from "./TextFieldReadonlyCopy.vue?vue&type=script&lang=js&"
import style0 from "./TextFieldReadonlyCopy.vue?vue&type=style&index=0&id=4697a02c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4697a02c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
